import { Andriod_ab_web_dp, IOS_af_web_dp } from '~/constants/af_web_dp';

export const createOnelink = (params: {
  url?: string;
  pid: string;
  testOpenUrl: string;
  deepLinkValue: Record<string, any>;
  afDp: string;
  afDpParams: Record<string, any>;
  ampExtra: Record<string, any>;
  isiOS: boolean;
  isMobile: boolean;
}) => {
  const {
    pid: onlinePid,
    url = 'https://lemon8.onelink.me/FMQw',
    testOpenUrl,
    deepLinkValue,
    afDp,
    afDpParams,
    ampExtra,
    isiOS,
    isMobile,
  } = params;

  // 1. if has is_test, go to the test url
  const searchParams = new URLSearchParams(window.location.search);
  const hasTestParams = searchParams.get('is_test') === '1';

  if (hasTestParams) {
    window.open(`snssdk2657test://${testOpenUrl}`);
    return;
  }

  // 2. if in test env, change the pid
  let pid = onlinePid;

  const isTest =
    window.location.host.includes(['bytedance', 'net'].join('.')) ||
    window.location.host.includes(['tiktok-row', 'net'].join('.'));
  if (isTest) {
    pid = 'ios_testing';
    if (isMobile) {
      if (!isiOS) {
        pid = 'android_testing';
      }
    }
  }

  // 3. generate af_dp
  let af_dp = afDp;

  Object.keys(afDpParams).forEach((key) => {
    af_dp += `&${key}=${afDpParams[key]}`;
  });

  // 4. onelink concat
  let onelink = `${url}?pid=${pid}`;
  onelink += `&deep_link_value=${encodeURIComponent(JSON.stringify(deepLinkValue))}`;
  onelink += `&af_dp=${encodeURIComponent(af_dp)}`;
  onelink += `&af_web_dp=${encodeURIComponent(isiOS ? IOS_af_web_dp : Andriod_ab_web_dp)}`;
  onelink += `&af_force_deeplink=true`;
  onelink += `&amp_extra=${encodeURIComponent(JSON.stringify(ampExtra))}`;

  return onelink;
};
